import { useQuery } from '@tanstack/react-query';

import type { FetchVideaImageIdResponse } from '@/@types/contracts';
import { fetchVideaImageId } from '@/app/external/utils';

import { endpoints } from './endpoints';

interface UseGetVideaImageParams {
  practicePatientId: string | null;
  primaryPracticeId: string | null;
  primaryOrganizationId: string | null;
  practiceImageId: string | null;
  onSuccess: (data: FetchVideaImageIdResponse) => void;
}

export const useGetVideaImage = ({
  practicePatientId,
  primaryPracticeId,
  primaryOrganizationId,
  practiceImageId,
  onSuccess,
}: UseGetVideaImageParams) => {
  const res = useQuery(
    [
      endpoints.getVideaImageId,
      practicePatientId,
      primaryPracticeId,
      primaryOrganizationId,
      practiceImageId,
    ],

    () =>
      fetchVideaImageId(
        practicePatientId,
        primaryPracticeId,
        primaryOrganizationId,
        practiceImageId,
      ),
    {
      enabled: !!practicePatientId && !!primaryPracticeId && !!practiceImageId,
      retryDelay: 5000,
      retry: 6,
      onSuccess,
    },
  );

  return res;
};
